// Dock navigation, foreground events and push can ask for the same three badge
// reads in one burst. Coalesce them; keep one trailing refresh, never a backlog.
export function createRefreshQueue(work: () => Promise<unknown>, minimumMs = 10_000) {
  let closed = false, running = false, requested = false;
  let nextAt = 0;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const request = () => {
    if (closed) return;
    requested = true;
    if (running || timer) return;
    const delay = nextAt - Date.now();
    if (delay > 0) { timer = setTimeout(() => { timer = undefined; request(); }, delay); return; }
    requested = false;
    running = true;
    nextAt = Date.now() + minimumMs;
    Promise.resolve().then(work).catch(() => {}).finally(() => {
      running = false;
      if (requested && !closed) request();
    });
  };
  return { request, close: () => { closed = true; clearTimeout(timer); } };
}
